import {useEffect, useState} from 'react';
import imges from "../assets/png";

const urls = [
    ...Object.values(imges)
]

const IMAGE_TIMEOUT = 20000;

export default function usePreloadImages() {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (urls.length === 0) {
            setReady(true);
            return;
        }

        Promise
            .all(
                urls.map(src =>
                    new Promise(resolve => {
                        const img = new Image();
                        let settled = false;
                        const finish = () => {
                            if (settled) return;
                            settled = true;
                            clearTimeout(timeoutId);
                            resolve();
                        };
                        const timeoutId = setTimeout(finish, IMAGE_TIMEOUT);
                        img.onload = img.onerror = finish;
                        img.src = src;
                    })
                )
            )
            .then(() => setReady(true));
    }, [urls]);

    return ready;
}
